export enum MetricDataInterval {
  "MINUTES_15" = "15MINUTES",
  "HOURS_24" = "24HOURS",
  "DAYS_7" = "7DAYS",
  "DAYS_30" = "30DAYS",
  "DAYS_90" = "90DAYS",
  "CURRENT_MONTH" = "MONTH",
  "LAST_MONTH" = "PREV_MONTH",
  "CURRENT_YEAR" = "YEAR",
  "LAST_YEAR" = "PREV_YEAR",
  "MONTHS_3" = "3MONTHS",
  "CUSTOM" = "CUSTOM",
}

export const MetricDataIntervalTitleMap: Record<MetricDataInterval, string> = {
  [MetricDataInterval.MINUTES_15]: "Live",
  [MetricDataInterval.HOURS_24]: "24 Hours",
  [MetricDataInterval.DAYS_7]: "Last 7 Days",
  [MetricDataInterval.DAYS_30]: "Last 30 Days",
  [MetricDataInterval.DAYS_90]: "Last 90 Days",
  [MetricDataInterval.CURRENT_MONTH]: "This Month",
  [MetricDataInterval.LAST_MONTH]: "Last Month",
  [MetricDataInterval.CURRENT_YEAR]: "This Year",
  [MetricDataInterval.LAST_YEAR]: "Last Year",
  [MetricDataInterval.MONTHS_3]: "3 Months",
  [MetricDataInterval.CUSTOM]: "Custom",
};
